// extracted by mini-css-extract-plugin
module.exports = {"grid":"grid__2O-p8","heading":"heading__aeseY","mainText":"mainText__27XOz","subText":"subText__csOLn","inline":"inline__3SBR0","inlineBlock":"inlineBlock__2lSJd"};